import { render, staticRenderFns } from "./CommentSettingsDialog.vue?vue&type=template&id=d262ce8e&scoped=true"
import script from "./CommentSettingsDialog.vue?vue&type=script&lang=js"
export * from "./CommentSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./CommentSettingsDialog.vue?vue&type=style&index=0&id=d262ce8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d262ce8e",
  null
  
)

export default component.exports